const formatHour = ({ date, language }) => {

  return date.toLocaleTimeString(language, {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default formatHour;
